module.exports = __webpack_public_path__ + "9b7e0aef8109bf3127f2da9c61ee8740.svg";